export default "__VITE_ASSET__BNTIO79W__"